module.exports = __webpack_public_path__ + "static/media/cribl-light-mode.1fb0a887.svg";